import React, {useRef, useState} from 'react';
import {useFrame, useLoader} from '@react-three/fiber';
import {Html} from '@react-three/drei';
import * as THREE from 'three';

export default function ProjectStar({project, isSelected, onSelect}) {
    const spriteRef = useRef();
    const [hovered, setHovered] = useState(false);
    const thumbnail = project?.images ? project?.images[0] : project?.image;
    const texture = useLoader(THREE.TextureLoader, thumbnail);

    useFrame((state) => {
        if (!spriteRef.current) return;

        const t = state.clock.getElapsedTime();
        const baseScale = hovered || isSelected ? 3.2 : 2.6;
        const pulse = Math.sin(t * 1.5 + project.position[0]) * 0.08;
        const scale = baseScale + pulse;

        spriteRef.current.scale.set(scale, scale, 1);
    });

    return (
        <group position={project.position}>
            <sprite
                ref={spriteRef}
                onClick={(e) => {
                    e.stopPropagation();
                    onSelect();
                }}
                onPointerOver={(e) => {
                    e.stopPropagation();
                    setHovered(true);
                    document.body.style.cursor = 'pointer';
                }}
                onPointerOut={() => {
                    setHovered(false);
                    document.body.style.cursor = 'auto';
                }}
            >
                <spriteMaterial
                    map={texture}
                    transparent
                    opacity={hovered || isSelected ? 1 : 0.9}
                />
            </sprite>

            {hovered && (
                <Html
                    position={[0, 2, 0]}
                    center
                    style={{pointerEvents: 'none'}}
                >
                    <div style={projectTooltip}>
                        {project.title}
                    </div>
                </Html>
            )}
        </group>
    );
}

const projectTooltip = {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    color: "black",
    fontSize: "40px",
    whiteSpace: "nowrap",
}

